import { tsValidateBoolean, tsValidateString, tsValidateUniqueId, tsValidateValue } from '@nu-art/ts-common';
import { FHIRResourceParamTypes } from './types.js';
import { knowledgeManagerDBGroup } from '@app/hcs-shared';
import { DBDef_FHIRResourceSubtype } from '../fhir-resource-subtype/index.js';
const Validator_ModifiableProps = {
    key: tsValidateString(),
    type: tsValidateValue([...FHIRResourceParamTypes]),
    description: tsValidateString(undefined, false),
    resourceSubtypeId: tsValidateUniqueId,
    isMultiValue: tsValidateBoolean(),
    isOptional: tsValidateBoolean(),
    isPostFiltered: tsValidateBoolean(),
};
const Validator_GeneratedProps = {};
export const DBDef_FHIRResourceParam = {
    modifiablePropsValidator: Validator_ModifiableProps,
    generatedPropsValidator: Validator_GeneratedProps,
    versions: ['1.0.0'],
    dbKey: 'fhir-resource-param',
    entityName: 'FHIR Resource Param',
    frontend: {
        group: knowledgeManagerDBGroup,
        name: 'fhir-resource-param'
    },
    backend: {
        name: 'fhir-resource-param'
    },
    dependencies: {
        resourceSubtypeId: {
            dbKey: DBDef_FHIRResourceSubtype.dbKey,
            fieldType: 'string',
        }
    }
};
//# sourceMappingURL=db-def.js.map